import { useCallback } from 'react'
import { useReactFlow } from '@xyflow/react'

/**
 * Hook that provides an onStateChange callback for React Flow custom nodes.
 *
 * Uses updateNodeData() for O(1) targeted updates instead of setNodes(map(...))
 * which was O(n) — iterating every node on the canvas per state change.
 */
export function useNodeStateChange(nodeId: string) {
  const { updateNodeData } = useReactFlow()

  const onStateChange = useCallback(
    (updater: ((prev: Record<string, unknown>) => Record<string, unknown>) | Record<string, unknown>) => {
      updateNodeData(nodeId, (node) => {
        const currentState = ((node.data as Record<string, unknown>)?.state as Record<string, unknown>) || {}
        const newState =
          typeof updater === 'function' ? updater(currentState) : { ...currentState, ...updater }

        return { state: newState }
      })
    },
    [nodeId, updateNodeData],
  )

  return onStateChange
}
